import React from 'react';
import { Navigate } from 'react-router-dom';

// PrivateRoute with role-based access control
const PrivateRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem('CC_Token'); // Retrieve the token from localStorage
  const user = JSON.parse(localStorage.getItem('user')); // Retrieve the user object with the correct key

  if (!token || !user) {
    // Redirect to login if no token or user information is available
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(user.role)) {
    // Redirect to "not authorized" page or a default route if role is not allowed
    return <Navigate to="/not-authorized" />;
  }

  // Render the protected element if all checks pass
  return element;
};

export default PrivateRoute;
